/** import React, { useState, useEffect } from "react";
import styled from "styled-components";

const ToggleButton = styled.div`
  position: relative;
  width: 75px;
  display: inline-block;
  vertical-align: middle;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  text-align: left;
  & input[type="checkbox"] {
    display: none;
  }
  & label {
    display: block;
    overflow: hidden;
    cursor: pointer;
    border: 0 solid #ccc;
    border-radius: 20px;
    margin: 0;

    & .toggle-switch-inner {
      display: block;
      width: 200%;
      margin-left: -100%;
      transition: margin 0.3s ease -in 0s;
      & ::before {
        display: block;
        float: left;
        width: 50%;
        height: 34px;
        padding: 0;
        line-height: 34px;
        font-size: 14px;
        color: white;
        font-weight: bold;
        box-sizing: border-box;
        content: attr(data - yes);
        text-transform: uppercase;
        padding-left: 10px;
        background-color: var(--gnorange);
        color: #fff;
      }
      & ::after {
        display: block;
        float: left;
        width: 50%;
        height: 34px;
        padding: 0;
        line-height: 34px;
        font-size: 14px;
        color: white;
        font-weight: bold;
        box-sizing: border-box;
        content: attr(data - no);
        text-transform: uppercase;
        padding-right: 10px;
        background-color: #ccc;
        color: #fff;
        text-align: right;
      }
    }
    & .toggle-switch-switch {
      display: block;
      width: 24px;
      margin: 5px;
      background: #fff;
      position: absolute;
      top: 0;
      bottom: 0;
      right: 40px;
      border: 0 solid #ccc;
      border-radius: 20px;
      transition: all 0.3s ease -in 0s;
    }
  }

  @media (max-width: 991px) {
    transform: scale(0.9);
  }
  @media (max-width: 767px) {
    transform: scale(0.825);
  }
  @media (max-width: 575px) {
    transform: scale(0.75);
  }
`;

const ToggleSwitch = (props) => {
  const [checked, setChecked] = useState(props.defaultChecked);

  const onChange = (e) => {
    const val = e.target.checked;
    setChecked(e.target.checked);
    if (typeof props.onChangeHandler === "function") {
      const timer = setTimeout(() => {
        props.onChangeHandler(val);
      }, 200);
      return () => clearTimeout(timer);
    }
  };

  useEffect(() => {
    setChecked(props.defaultChecked);
  }, [props.defaultChecked]);

  return (
    <div className={props.isBig ? "toggle-switch big-switch" : "toggle-switch"}>
      <input
        type="checkbox"
        className="toggle-switch-checkbox"
        name={props.Name}
        id={props.Name}
        checked={checked}
        defaultChecked={props.defaultChecked}
        onChange={onChange}
        disabled={props.disabled}
      />
      <label className="toggle-switch-label" htmlFor={props.Name}>
        <span
          className="toggle-switch-inner"
          data-yes={props.dataYes}
          data-no={props.dataNo}
        />
        <span className="toggle-switch-switch" />
      </label>
    </div>
  );
};
export default ToggleSwitch;
*/
import React, { useState, useEffect } from "react";
import styled from "styled-components";

const ToggleButton = styled.div`
  position: relative;
  width: 75px;
  display: inline-block;
  vertical-align: middle;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  text-align: left;
  & input[type="checkbox"] {
    display: none;
  }
  & label {
    display: block;
    overflow: hidden;
    cursor: pointer;
    border: 0 solid #ccc;
    border-radius: 20px;
    margin: 0;

    & .toggle-switch-inner {
      display: block;
      width: 200%;
      margin-left: -100%;
      transition: margin 0.3s ease;
      &::before {
        display: block;
        float: left;
        width: 50%;
        height: 34px;
        padding: 0;
        line-height: 34px;
        font-size: 14px;
        color: white;
        font-weight: bold;
        box-sizing: border-box;
        content: attr(data-yes);
        text-transform: uppercase;
        padding-left: 10px;
        background-color: var(--gnorange);
        color: #fff;
      }
      &::after {
        display: block;
        float: left;
        width: 50%;
        height: 34px;
        padding: 0;
        line-height: 34px;
        font-size: 14px;
        color: white;
        font-weight: bold;
        box-sizing: border-box;
        content: attr(data-no);
        text-transform: uppercase;
        padding-right: 10px;
        background-color: #ccc;
        color: #fff;
        text-align: right;
      }
    }
    & .toggle-switch-switch {
      display: block;
      width: 24px;
      margin: 5px;
      background: #fff;
      position: absolute;
      top: 0;
      bottom: 0;
      right: 40px;
      border: 0 solid #ccc;
      border-radius: 20px;
      transition: all 0.3s ease;
    }
  }

  @media (max-width: 991px) {
    transform: scale(0.9);
  }
  @media (max-width: 767px) {
    transform: scale(0.825);
  }
  @media (max-width: 575px) {
    transform: scale(0.75);
  }

  /* basic checked styles */
  &
    .toggle-switch-checkbox:checked
    + .toggle-switch-label
    .toggle-switch-inner {
    margin-left: 0;
  }
  &
    .toggle-switch-checkbox:checked
    + .toggle-switch-label
    .toggle-switch-switch {
    right: 0;
  }
`;

const ToggleSwitch = (props) => {
  // Determine controlled vs uncontrolled
  const isControlled = typeof props.checked !== "undefined";

  const initial = isControlled
    ? props.checked
    : typeof props.defaultChecked !== "undefined"
    ? props.defaultChecked
    : false;

  const [checked, setChecked] = useState(initial);

  // Keep internal state in sync when controlled prop changes
  useEffect(() => {
    if (isControlled) {
      setChecked(props.checked);
    }
  }, [props.checked, isControlled]);

  // Keep internal state in sync when defaultChecked changes (uncontrolled)
  useEffect(() => {
    if (!isControlled) {
      setChecked(
        typeof props.defaultChecked !== "undefined"
          ? props.defaultChecked
          : false
      );
    }
  }, [props.defaultChecked, isControlled]);

  const onChange = (e) => {
    const newVal = e.target.checked;

    // Update internal state only when uncontrolled
    if (!isControlled) {
      setChecked(newVal);
    }

    // Notify parent - parent should set checked prop (controlled) if it wants to keep change,
    // or set it back to false if user cancelled — that will update this component via props.checked
    if (typeof props.onChangeHandler === "function") {
      try {
        props.onChangeHandler(newVal, e);
      } catch (err) {
        // swallow errors from handler to avoid breaking toggle; parent should handle
        // optionally revert internal state if uncontrolled
        if (!isControlled) setChecked(!newVal);
      }
    }
  };

  return (
    <ToggleButton className={props.className}>
      <input
        type="checkbox"
        className="toggle-switch-checkbox"
        name={props.Name}
        id={props.Name}
        checked={checked}
        onChange={onChange}
        disabled={props.disabled}
      />
      <label className="toggle-switch-label" htmlFor={props.Name}>
        <span
          className="toggle-switch-inner"
          data-yes={props.dataYes || "YES"}
          data-no={props.dataNo || "NO"}
        />
        <span className="toggle-switch-switch" />
      </label>
    </ToggleButton>
  );
};

export default ToggleSwitch;
